"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FABButton = void 0;
const modal_1 = require("./modal");
class FABButton {
    /** Init */
    init() {
        this.FABAnchorLink();
        this.FABExternalLink();
        this.FABPrint();
    }
    /** FAB Anchor Link */
    FABAnchorLink() {
        jQuery('.fab-link-type-anchor_link').each(function () {
            let index = window.FAB_PLUGIN.to_display.findIndex((e) => e.ID === jQuery(this).data('id'));
            let fab = window.FAB_PLUGIN.to_display[index];
            jQuery(this).on('click', function () {
                let anchorTopPadding = 30;
                let position = jQuery(fab.link).offset().top;
                position = (position >= anchorTopPadding) ? position - anchorTopPadding : position;
                window.FAB_PLUGIN.modules.button.scrollTo(document.documentElement, position, fab.module.options.duration.value);
                return false;
            });
        });
    }
    /** FAB External Link */
    FABExternalLink() {
        window.FAB_PLUGIN.to_display.map((e) => {
            jQuery(`.fabelink-${e.ID}`).on('click', function () {
                jQuery(`#fab-link-${e.ID}`).click();
            });
        });
    }
    /** FAB Print */
    FABPrint() {
        jQuery('.fab-link-type-print').on('click', function () {
            let ID = jQuery(this).closest('.fab-link-container').data('id');
            let fab = window.FAB_PLUGIN.to_display.find(e => e.ID == ID);
            let option = fab.extraOptions.print;
            if (option && option.target !== 'body') {
                const printJS = require("print-js");
                let target = option.target.replace('#', '');
                let type = 'html';
                type = (['.jpg', '.png', '.gif'].includes(type)) ? 'image' : type;
                type = (['.pdf'].includes(type)) ? '' : type;
                printJS(target, type);
            }
            else {
                window.print();
            }
        });
    }
    /** Smooth Scroll To with Duration */
    scrollTo(element, to, duration) {
        let start = element.scrollTop, change = to - start, currentTime = 0, increment = 20;
        let easeInOutQuad = function (t, b, c, d) {
            t /= d / 2;
            if (t < 1)
                return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        };
        let animateScroll = function () {
            currentTime += increment;
            const val = easeInOutQuad(currentTime, start, change, duration);
            element.scrollTop = val;
            if (currentTime < duration) {
                setTimeout(animateScroll, increment);
            }
        };
        animateScroll();
    }
    /** Trigger Click */
    static triggerClick(ID) {
        /** Close Any Open Modal */
        modal_1.FABModal.CloseDialog();
        /** Trigger Click */
        let dom = jQuery(`#${ID}`);
        if (!dom.attr('href')) {
            /** Trigger Open Modal */
            dom.trigger('click');
        }
        else {
            /** Trigger Open Link */
            if (dom.attr("target") === "_blank") {
                window.open(dom.attr('href'));
            }
            else {
                window.location = dom.attr('href');
            }
        }
    }
}
exports.FABButton = FABButton;
